export enum ToastAnimationDirection {
  UP = 'up',
  DOWN = 'down',
}
